import React from 'react';
import { Box } from '@material-ui/core';
import Typography from '../Typography';
import { useTrans } from '../../../services/i18n';

const CapabilityRestrictedBanner = () => {
  const { trans } = useTrans();

  return (
    <Box
      mb={2}
      px={2}
      py={1.5}
      style={{
        backgroundColor: '#f1f3f9',
        border: '1px solid #dce0e8',
        borderRadius: 8,
      }}
    >
      <Typography variant="body2" color="hint">
        {trans('capability-read-only-message')}
      </Typography>
    </Box>
  );
};

export default CapabilityRestrictedBanner;
